import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconEmail2Unread: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconEmail2Unread"><Path d="M22 7.38379C22 8.0447 21.6273 8.64988 21.0371 8.94727L13.2373 12.877C12.459 13.2691 11.541 13.2691 10.7627 12.877L3.5 9.21777V17.25C3.5 17.9404 4.05964 18.5 4.75 18.5H11.25C11.6642 18.5 12 18.8358 12 19.25C12 19.6642 11.6642 20 11.25 20H4.75C3.23122 20 2 18.7688 2 17.25V6.75C2 5.23122 3.23122 4 4.75 4H19.25C20.7687 4.00004 22 5.23125 22 6.75V7.38379Z" fill="currentColor"/><Circle cx="19.5" cy="17.5" r="3.5" fill="currentColor"/></CentralIconBase>;
});

export default IconEmail2Unread;
